export default __webpack_public_path__ + "static/codeplatform-ai-e5ff3e5c696209edc299dfc973941229.png";